module.exports = __webpack_public_path__ + "img/Sharda_Logo.01ce9c64.png";